import { createModel, RematchDispatch } from '@rematch/core';
import { produce } from 'immer';

import baseEntity from './base.entity';
import { RootModel } from '../models';
import { UserContactTypes } from '../../types';
import { getUserContactByCode } from '../../services/userContact.service';
import { storeName as layoutModelStore } from '../models/layout.model';
import { UserContactResponseTypes } from '../../types/response/userContact';
import { convertAssignedContactResponse } from '../../utils/convertUtils/assignedContact';

export const storeName = 'userContactEntity';

export const userContactEntity = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
    saves: produce((state, entities: UserContactTypes[]) => {
      (entities || []).forEach((entity: UserContactTypes) => {
        state.ids[entity.code] = entity;
      });
    }),
  },

  effects: (dispatch: RematchDispatch<typeof userContactEntity>) => ({
    async loadByCodeAndAlias(payload, state: RootModel) {
      const { locale } = state[layoutModelStore];
      const response: UserContactResponseTypes[] = await getUserContactByCode(
        payload.code,
        payload.alias,
        locale.apiLanguage
      );
      // check case not set data on cms
      if (!response) {
        return [];
      }
      const assignedContacts = response.map((item) => convertAssignedContactResponse(item));
      const userContacts = (assignedContacts || []).map((assign) => {
        const userContact = {
          ...assign.userContact,
          aliasAssigned: assign.alias,
          token: assign.token,
        };
        return userContact;
      });
      this.saves(userContacts);
      return userContacts;
    },
  }),
});

export default userContactEntity;
